import { CatDropdown } from '@blocks-react/components/Dropdown';
import { getNotation } from './utils';
import { CatList } from '@blocks-react/components/List';
import { CatListItem } from '@blocks-react/components/ListItem';
import { GuestDropDownWithFieldProps } from './types';

const GuestDropDownSharedForm = ({
  name,
  fieldId,
  label,
  isTypeahead,
  dropdownField,
  error,
  required = false,
  className,
  t,
  dropdownOptions,
  ...rest
}: GuestDropDownWithFieldProps) => {
  return (
    <CatDropdown
      {...dropdownField}
      notation={getNotation(t, required)}
      data-testid={`address-dropdown-${fieldId}`}
      fieldId={fieldId}
      name={name}
      label={label}
      status={error ? 'error' : undefined}
      position="bottom-start"
      className="data-cs-mask"
      data-cs-mask
      required
      {...rest}
    >
      <div className={className}>
        <CatList>
          <CatListItem value="" key={t('SELECT_AN_OPTION')}>
            {t('SELECT_AN_OPTION')}
          </CatListItem>
          {dropdownOptions?.map(({ code, displayName }) => (
            <CatListItem key={code} value={code}>
              {displayName}
            </CatListItem>
          ))}
        </CatList>
      </div>
    </CatDropdown>
  );
};

export default GuestDropDownSharedForm;
